export default "__VITE_ASSET__B4onY2Yo__"